import { useContext, useMemo } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import { insertBoldText } from "../../helpers/insertBoldText";
import { getCompanySlug } from "../../selectors";
import { USE_EXPERIMENT_COMPANY_MAIN_BENEFITS_VARIATION } from "../../store/variations/constants";
import { getVariations } from "../../store/variations/selectors";
import { CompanyContext } from "../CompanyList/CompanyContext";

export const BaseBenefitsList = (props) => {
	const { company } = useContext(CompanyContext);
	const companySlug = useSelector((state) =>
		getCompanySlug(state, { company }),
	);

	const variations = useSelector(getVariations);
	const pumpkinVariation = variations?.[companySlug]?.["fuid_946"];
	const isPumpkinVariation =
		pumpkinVariation === USE_EXPERIMENT_COMPANY_MAIN_BENEFITS_VARIATION;

	const benefitsArray = useMemo(() => {
		const fields = company?.fields || {};

		if (isPumpkinVariation && fields.alternateCompanyMainBenefits?.length) {
			return fields.alternateCompanyMainBenefits;
		}

		return fields.companyMainBenefits || [];
	}, [company?.fields, isPumpkinVariation]);

	const formattedBenefitsList = useMemo(
		() => insertBoldText(benefitsArray),
		[benefitsArray],
	);

	const companyBenefits = formattedBenefitsList.map((benefit, idx) => (
		<li key={idx} className={props?.listItem}>
			{props?.icon}
			<span className="tw-leading-inherit tw-text-inherit">{benefit}</span>
		</li>
	));

	return (
		<div className={props?.wrapper}>
			<ul className={props?.list}>{companyBenefits}</ul>
		</div>
	);
};

BaseBenefitsList.propTypes = {
	wrapper: PropTypes.string,
	list: PropTypes.string,
	listItem: PropTypes.string,
	icon: PropTypes.element,
};
